import React from 'react';
import { chooseYourOwnPriceConfiguration } from "./LineItemUnitPriceTypes"
import { CurrencyAmount, FormatCurrencyValue, formatCurrencyValue } from "../../../utils/currency"
import GACurrencyInput, { GACurrencyInputOnChangeValues } from '../../inputs/GACurrencyInput';

/**
 * Implmentation of the Choose your own unit price type, where the user may input their preferred price.
 */

/**Component interface:
 * lineItemName: Name of line item
 * uniPriceConfiguration: Configuration of the unit price.
 * onPriceChange: Callback when the price is adjusted. Used for total price calculations and sending to payment processing.
 * onPriceValidityChange: Callback when the price validity is adjusted. Used for determining whether line item is valid for payment submission.
 *      errorMsg is for the message to be displayed below the checkout button.
 * onPriceDisplayChange: Callback when the value to be displayed in the unit price display changes.
 */
interface ChooseYourOwnUnitPriceDisplayProps {
    lineItemId: number
    lineItemName: string
    unitPriceConfiguration: chooseYourOwnPriceConfiguration,
    onPriceChange: (lineItemId : number, newAmount:CurrencyAmount) => void,
    onPriceValidityChange: (lineItemId: number, isValid: boolean, errormMsg?: string) => void,
    onPriceDisplayChange: (newValue: string) => void,
    disableInputs?: boolean
}

const ChooseYourOwnUnitPriceDisplay = (props: ChooseYourOwnUnitPriceDisplayProps) =>
{
    const [displayError, setDisplayError] = React.useState<boolean>(false);
    const [amount, setAmount] = React.useState<GACurrencyInputOnChangeValues>({...props.unitPriceConfiguration.defaultPrice.value, name: undefined});

    const minAmount = formatCurrencyValue(props.unitPriceConfiguration.minAmount, props.unitPriceConfiguration.defaultPrice.currency.formatting);

    /**
     * Handler called onBlur that determines validity and sends new values if valid
     * @param change: New input value
     */
    const onUnitPriceBlur = (change: GACurrencyInputOnChangeValues) => 
    {
        setAmount(change);
    }

    const updateUnitPrice = () =>
    {
        const newValid = (amount?.float && amount?.float != null && amount.float >= props.unitPriceConfiguration.minAmount) ? true: false;
        setDisplayError((amount?.float == null || amount?.float == 0) ? false : !newValid);
        if(newValid  == true)
        {
            props.onPriceDisplayChange(amount.formatted ? amount.formatted : "");
            props.onPriceChange(props.lineItemId, {
                currency: props.unitPriceConfiguration.defaultPrice.currency,
                value: {...amount}
            });
        }
        else
        {
            props.onPriceDisplayChange("$-.--");
        }
        props.onPriceValidityChange(props.lineItemId, newValid, newValid ? undefined : `Waiting for ${props.lineItemName} amount`);
    }

    return(
    <div className='checkoutChooseYourPriceInput'>
            <div className='checkoutChooseYourPriceInputBox'>
                <GACurrencyInput
                    className='checkoutChooseYourPriceInputBox'
                    name={props.unitPriceConfiguration.componentName.concat('CurrencyInput')}
                    currency={props.unitPriceConfiguration.defaultPrice.currency}
                    onInputBlur={onUnitPriceBlur}
                    disabled={props.disableInputs ?? false}
                    min={0}
                    max={props.unitPriceConfiguration.maxAmount}
                    defaultValue={props.unitPriceConfiguration.defaultPrice.value.float}
                />
            </div>
        <div className='checkoutChooseYourPriceUpdate'>
            <button onClick={updateUnitPrice}>Update</button>
        </div>
        {displayError && 
        <div className='checkoutChooseYourPriceError'>
            <p className='checkoutPageTextError'>Donation below minimum transaction amount ({minAmount.formatted})</p>
        </div>}
    </div>)
}

export default ChooseYourOwnUnitPriceDisplay;